const state = () => ({
    video: null
});


const mutations = {
    SET_VIDEO(state, data) {
        state.video = data
    },
}

const actions = {
    setVideo({ commit
    }, data) {
        commit('SET_VIDEO', data)
        return data
    },
}
const getters = {}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};